module.exports = __webpack_public_path__ + "img/221-tuvalu.83a8d80c.svg";